import { useMemo } from 'react';

import { useHandleQuery } from 'hooks';
import {
  useDestinationsQuery,
  useLazyDestinationTenantsQuery,
  useLazyDestinationProjectsQuery,
} from 'store/api/replication';

export const useCrossEnvData = () => {
  const {
    data: destinations,
    isFetching: isDestinationsFetching,
    ...destinationsQueryProps
  } = useDestinationsQuery();

  const [
    fetchDestinationTenants,
    {
      isFetching: isTenantsFetching,
      currentData: destinationTenants,
      ...destinationTenantsQueryProps
    },
  ] = useLazyDestinationTenantsQuery();

  const [
    fetchDestinationProjects,
    {
      isFetching: isProjectsFetching,
      currentData: destinationProjects,
      ...destinationProjectsQueryProps
    },
  ] = useLazyDestinationProjectsQuery();

  useHandleQuery(destinationsQueryProps);
  useHandleQuery(destinationTenantsQueryProps);
  useHandleQuery(destinationProjectsQueryProps);

  const destinationOptions = useMemo(
    () => (destinations ?? []).map((d) => ({ label: d.name, value: d.name })),
    [destinations]
  );

  const destinationTenantOptions = useMemo(
    () =>
      (destinationTenants ?? []).map((t) => ({ value: t.id, label: t.name })),
    [destinationTenants]
  );

  const destinationProjectOptions = useMemo(
    () =>
      (destinationProjects ?? []).map((p) => ({ value: p.id, label: p.name })),
    [destinationProjects]
  );

  return {
    isTenantsFetching,
    isProjectsFetching,
    destinationOptions,
    isDestinationsFetching,
    fetchDestinationTenants,
    fetchDestinationProjects,
    destinationTenantOptions,
    destinationProjectOptions,
  };
};
